const totalPhotos = Array(107).keys()

export const listPhotos =  Array.from(totalPhotos).map((_,i) => {
  const idPhoto = (i+1)
  const alt = 'Foto dos alunos dos projetos sociais da Associação Araxá Taewkondo treinando na academia'
  return {src:`/fotos/${idPhoto}.jpeg`,alt}
}).reverse()